import Modal from 'react-modal';
import React from 'react';
import axios from 'axios';
import LoadingSpinner from '../../common/LoadingSpinner';
import { TQualifyingQuestion } from '../../postjob/rolecard/agentview/QualifyingQuestions';
import { getCSRFToken, ROOT_URL_V2 } from '../../../config';
import { getErrorMessages } from '../../../utils';
import { TPageNotification } from '../../../types';


type TModalConfirmEditSeriesProps = {
    notification: TPageNotification;
    reloadData: () => void;
    isOpen: boolean;
    handleClose: () => void;
    handleCloseParentModal: () => void;
    fields: TQualifyingQuestion[];
    seriesId: number;
    setError: (error: string) => void;
}

export function ModalConfirmEditSeriesQuestions({
    notification,
    reloadData,
    isOpen,
    handleClose,
    handleCloseParentModal,
    fields,
    seriesId,
    setError,
}: TModalConfirmEditSeriesProps) {

    const [isLoading, setIsLoading] = React.useState(false);
    const payloadData = {
        jobs_only: true,
        qualifying_questions: Object.values(fields).
            filter(field => field.content !== null && field.content !== '' && field.correct_answer !== null),
    };

    const handleConfirm = (): void => {
        setIsLoading(true);

        axios({
            method: 'patch',
            url: `${ROOT_URL_V2}series/${seriesId}/update_series/`,
            data: payloadData,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        }).then(() => {
            setIsLoading(false);
            handleClose();
            handleCloseParentModal();
            notification.success(
                'Success',
                `${seriesId} successfully edited`
            );
            reloadData();
        }).catch(err => {
            setIsLoading(false);
            setError(getErrorMessages(err));
            handleClose();
        });
    };

    const finalFieldsLength = Object.values(fields).map(field =>
        field.content.trim()).filter(content => content !== '').length;

    return (
        <Modal
            className="add-qualifying-questions-modal"
            isOpen={isOpen}
            onRequestClose={handleClose}
            contentLabel="Confirm questions"
            ariaHideApp={false}
        >
            <p className="modal-title">Update qualifying questions</p>
            <div className="qualifying-questions-form">
                {finalFieldsLength > 0
                    ? (
                    <div>
                        <p>Are you sure you want to update qualifying questions on the ongoing job <b>{seriesId}</b>?</p>
                        <table>
                            <thead>
                            <tr>
                                <th style={{ textAlign: 'left' }}>Question</th>
                                <th>Correct Answer</th>
                            </tr>
                            </thead>
                            <tbody>
                            {Object.keys(fields).map(key => (
                                // eslint-disable-next-line react/no-array-index-key
                                <tr key={key}>
                                    <td
                                        className="qualifying-questions-field"
                                        style={{ textAlign: 'left' }}
                                    >
                                        {fields[Number(key)]?.content}
                                    </td>
                                    <td>
                                        {/* eslint-disable-next-line no-nested-ternary */}
                                        <b>{fields[Number(key)]?.correct_answer !== null ? (fields[Number(key)]?.correct_answer ? 'Yes' : 'No') : null}</b>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>)
                    : (<p style={{ color: 'red' }}>
                            Are you sure you want to save the ongoing job <b>{seriesId}</b> with <b>NO</b> qualifying questions?
                        </p>)
                }
                </div>
            <button
                className="continue btn--round-big"
                onClick={handleConfirm}
                type="button"
                disabled={isLoading}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="edit-series-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            {!isLoading && (
                <button className="back" onClick={handleClose} type="button">
                    CANCEL
                </button>
            )}
        </Modal>
    );
}
